import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, AbstractControl } from '@angular/forms';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fixed-lettrage-bp-array',
  templateUrl: './fixed-lettrage-bp-array.component.html',
  styleUrls: ['./fixed-lettrage-bp-array.component.scss']
})
export class FixedLettrageBpArrayComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  @Output() onLinckClick = new EventEmitter<boolean>();
  bcLineFormArray: UntypedFormArray;
  displayedColumnsBC: string[] = ['code', 'libelle', 'bpList', 'numFactures'];
  matDataSourceBCLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.onLinckClick.emit(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.form) {
      this.bcLineFormArray = this.form.controls["bcLines"] as UntypedFormArray;
      this.reload();
    }
  }

  reload(): void {
    if (this.bcLineFormArray) {
      this.matDataSourceBCLigne = new MatTableDataSource<AbstractControl>(this.bcLineFormArray.controls);
      setTimeout(() => this.matDataSourceBCLigne.paginator = this.paginator, 100);
    }
  }

  goToBp(idbp: number): void {
    this.onLinckClick.emit(true);
    const newRelativeUrl = this.router.createUrlTree(['read-bp/' + idbp]);
    const baseUrl = window.location.href.replace(this.router.url, '');
    const url = baseUrl + newRelativeUrl
    if (url.startsWith(environment.API_END_POINT_URL) ){
      window.open(url, '_blank');
    }
  }
}
